import * as Sentry from '@sentry/react';
import { usePostHog } from 'posthog-js/react';
import React, { ReactNode, useEffect, useState } from 'react';
import { useAuth } from '~/contexts/AuthContext/AuthProvider';
import { useGetUserInfoAndCompaniesQuery } from '~/store/apis/endpoints/userManagementApi/userManagement.api';
import { IUserContext, UserContext } from './UserContext';
export { useUser } from './UserContext';

const emptyUserState: IUserContext = {};

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated } = useAuth();
  const [userState, setUserState] = useState<IUserContext>(emptyUserState);
  const posthog = usePostHog();

  const { data: userInfo } = useGetUserInfoAndCompaniesQuery(undefined, {
    skip: !isAuthenticated,
  });

  useEffect(() => {
    if (userInfo) {
      const userQCode = userInfo.user.qcode;
      if (userQCode) {
        posthog.identify(userQCode);
        Sentry.setUser({ id: userQCode });
      }
      setUserState({
        user: userInfo.user,
        companies: userInfo.companies,
      });
    }
  }, [userInfo]);

  return (
    <UserContext.Provider value={userState}>{children}</UserContext.Provider>
  );
};
